'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = transformable;

var _utils = require('../utils');

var _constants = require('../constants');

function getEntry(v) {
    return v && ((0, _utils.is)(v, 'symbol') ? v : v[_constants.ENTRY]);
}

function transformable(fn) {
    var transformations = [];

    function exec() {
        var _this = this;

        return transformations.reduce(function (r, f) {
            var entry = getEntry(r);
            var result = f.call(_this, r);

            if (entry && (0, _utils.isNil)(result)) return _constants.ENTRY;

            if ((0, _utils.is)(result, 'symbol')) return result;

            if (entry && result && result[_constants.ENTRY] !== entry) result[_constants.ENTRY] = entry;

            return result;
        }, fn.call(this));
    }

    function transform(t) {
        transformations.push(t);
        return exec;
    }

    fn.transform = transform;
    exec.transform = transform;

    return fn;
}